export default "__VITE_ASSET__DxX6qOHH__"